import { Box, SvgIcon, Typography } from "@mui/material"
import { ReactComponent as DangerIcon } from "static/svg/alerts/danger.svg"

const DangerCard = ({ item, size = "normal" }) => {
  return (
    <Box>
      <Box
        sx={{
          display: "inline-flex",
          alignContent: "center",
          p: size === "normal" ? 1 : 0.5,
          backgroundColor: "#FFD8DC",
          borderRadius: "8px",
        }}
      >
        <Typography variant={size === "normal" ? "body2" : "caption"} sx={{ fontWeight: 500 }}>
          {item.name}
        </Typography>
        {size === "normal" && (
          <SvgIcon component={DangerIcon} inheritViewBox sx={{ ml: 1, width: 18, height: 18 }} />
        )}
      </Box>
    </Box>
  )
}

export default DangerCard
